import { render, staticRenderFns } from "./RestaurantCtaList.vue?vue&type=template&id=4a41e3d0&scoped=true&"
import script from "./RestaurantCtaList.vue?vue&type=script&lang=js&"
export * from "./RestaurantCtaList.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantCtaList.vue?vue&type=style&index=0&id=4a41e3d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a41e3d0",
  null
  
)

export default component.exports